module.exports = __webpack_public_path__ + "static/img/lazada-logo.13e83c38.png";